import { DoorConfiguration } from '../../configurator/DoorConfiguration';
import functionsService from '../../services/Configurator/FunctionsService';
import frameSelectionService from '../../services/Configurator/FrameSelectionService';
import measureService from '../../services/Configurator/MeasureService';
import { Characteristic, ValueDefinition, MapCharacteristicAndValue } from '../../configurator/types';
import store from '@/store/index';
import * as formula from '../../configurator/CharacteristicFormula';
import * as otherFormula from '../../configurator/CalculatedCharacteristics/MeasurementsCharacteristics';
import * as absenkdichtung from '../../configurator/CalculatedCharacteristics/AbsenkdichtungCharacteristic';
import {parseToGermanFloat, parseFloatFromGermanFloat} from '../../services/ParserService';
import * as helper from '../../configurator/CalculatedCharacteristics/Shared';

const addSingleCharacteristicsFilteredOrDefaults = (s: any) => {
    const frameCharacteristics = s.model.characteristics;
    frameCharacteristics.forEach((char: any) => {
        if (char.values.length === 1) {
            const selectedCharacteristic = MapCharacteristicAndValue(char, char.values[0]);
            const currentDoorConfiguration = store.getters['configuratorModule/getCurrentDoorConfiguration'];
            currentDoorConfiguration.Add(DoorConfiguration.Measure, selectedCharacteristic);
        } else {
            var geter = store.getters['configuratorModule/getRegisteredCharacteristicsValue'];
            const regChar = geter(char.code, DoorConfiguration.Measure);
            const exists = regChar.id === char.id;
            const registeredValue = char.values.filter((x: any) => x.id === regChar.value.id)[0];
            const incorrectValue = typeof registeredValue === 'undefined' ? true : false;
            if (exists === false || incorrectValue === true) {
                const valueItem = char.values[0];
                const selectedCharacteristic2 = MapCharacteristicAndValue(char, valueItem);
                const currentDoorConfiguration = store.getters['configuratorModule/getCurrentDoorConfiguration'];
                currentDoorConfiguration.Add(DoorConfiguration.Measure, selectedCharacteristic2);
            }
        }
    });
};

const addOrReplaceCharacteristic = (returnedCharacteristic: any, s: any) => {
    const characteristic = returnedCharacteristic;
    const modelCharacteristics = s.model.characteristics;

    let filteredCharacteristic: any;
    filteredCharacteristic = modelCharacteristics.filter((item: any) => item.code === characteristic.code);
    if (filteredCharacteristic.length !== 0) {
        if (filteredCharacteristic[0].id === characteristic.id) {
            const characteristicIndex: number = modelCharacteristics.indexOf(filteredCharacteristic[0]);
            modelCharacteristics.splice(characteristicIndex, 1, characteristic);
        }
    } else {
        modelCharacteristics.push(characteristic);
    }
};

const getCharacteristic = (code: string, s: any) => {
    const filteredCharacteristic = s.model.characteristics.filter((characteristic: any) => characteristic.code === code)[0];

    if (typeof filteredCharacteristic !== 'undefined') {
        return filteredCharacteristic;
    } else {
        return s.defaultCharacteristicObject;
    }
};

const getNrOfValues = (code: string, s: any) => {
    const filteredCharacteristic = s.model.characteristics.filter((characteristic: any) => characteristic.code === code)[0];
    if (typeof filteredCharacteristic !== 'undefined') {

        return filteredCharacteristic.values.length;
    } else {
        return 0;
    }
};

const checkValue = (characteristicCode: string, value: string, s: any) => {
    const definedValues = store.getters['configuratorModule/getCurrentDoorConfiguration'].Get(DoorConfiguration.Measure);
    const filteredCharacteristic: any = definedValues.filter((item: any) => item.code === characteristicCode && item.value.value === value)[0];

    if (filteredCharacteristic != null || typeof filteredCharacteristic !== 'undefined') {
        return true;
    }
    return false;
};

const getAppropValue = (characteristicCode: string, context: any) => {
    const characteristic = getCharacteristic(characteristicCode, context.state);
    var geter = store.getters['configuratorModule/getRegisteredCharacteristicsValue'];
    const registeredCharacteristic = geter(characteristicCode, DoorConfiguration.Measure);
    let valueDefinition;

    if (characteristic.values.length > 1) {
        valueDefinition = characteristic.values.filter((x: any) => x.id !== registeredCharacteristic.value.id)[0];
    } else {
        valueDefinition = characteristic.values[0];
    }

    const selectedCharacteristic = MapCharacteristicAndValue(characteristic, valueDefinition);
    return selectedCharacteristic;
};

const getDefaultState = () => {
    return {
        model: {
            modelUnlocked: false,
            characteristics: [],
            modelStatus: {
                active: false,
            },
            materials: [],
            threshold: {
                HeightValueVS : 0,
                HeightValueBS : 0,
                HeightValue: 0,
            },
            trafficDoor: {
                WidthSym: 0,
                WidthAsym: 0,
                Width: 0,
            },
            doorMeasure: {
                width: 0,
                heightBS: 0,
                heightGBS: 0,
            },
        },
        doorLeafCharacteristic: {
            characteristics: ['KTU_MM_TUERBL_KUERZUNG', 'KTU_MM_TUERBL_VERLAENGERUNG'],
            characteristic: '',
        },
        doorLeafSizes: [],
        defaultCharacteristicObject: {
            id: 0,
            description: 'Static Characteristic Description',
            code: 'CHARACTERISTIC_CODE',
            values: [
                {
                    id: 0,
                    description: 'Static Value Description',
                    value: 'No Val',
                    resource: '',
                },
            ],
        },
    }
};

const state = {
    model: {
        modelUnlocked: false,
        characteristics: [],
        modelStatus: {
            active: false,
        },
        materials: [],
        threshold: {
            HeightValueVS : 0,
            HeightValueBS : 0,
            HeightValue: 0,
        },
        trafficDoor: {
            WidthSym: 0,
            WidthAsym: 0,
            Width: 0,
        },
        doorMeasure: {
            width: '',
            heightBS: 0,
            heightGBS: 0,
        },
    },
    doorLeafCharacteristic: {
        characteristics: ['KTU_MM_TUERBL_KUERZUNG', 'KTU_MM_TUERBL_VERLAENGERUNG'],
        characteristic: '',
    },
    doorLeafSizes: [],
    defaultCharacteristicObject: {
        id: 0,
        description: 'Static Characteristic Description',
        code: 'CHARACTERISTIC_CODE',
        values: [
            {
                id: 0,
                description: 'Static Value Description',
                value: 'No Val',
                resource: '',
            },
        ],
    },
};

const getters = {
    getMeasureCharacteristics: (s: any) => s.model.characteristics,
    // This should be used for displaying characteristics and values in components (should replace all getKTU_MM_XYZ)
    getCharacteristicAndValues: (s: any) => {
        return (characteristicCode: string) => getCharacteristic(characteristicCode, s);
    },
    getNrOfValuesByCharacteristic: (s: any) => {
        return (characteristicCode: string) => getNrOfValues(characteristicCode, s);
    },
    checkRadioValue: (s: any) => {
        return (characteristicCode: string, value: string) => checkValue(characteristicCode, value, s);
    },
    getSelectedDoorLeafCharacteristic: (s: any) => {
        return s.doorLeafCharacteristic;
    },
    getMaterials: (s: any) => {
        return s.model.materials;
    },
    getThreshold: (s: any) => {

        return s.model.threshold;
    },
    getTrafficDoor: (s: any) => {
        return s.model.trafficDoor;
    },
    getDoorMeasure: (s: any) => {
        let measure = s.model.doorMeasure;
        let t = parseToGermanFloat(measure.width);
        measure.width = parseToGermanFloat(measure.width);
        measure.heightBS = parseToGermanFloat(measure.heightBS);
        measure.heightGBS = parseToGermanFloat(measure.heightGBS);

        return s.model.doorMeasure;
    },
    getDoorLeafSizes: (s: any) => {
        return s.doorLeafSizes;
    }
};

const actions = {
    setMeasureCharacteristics(context: any, payload: any) {
        context.commit('updateMeasureCharacteristics', payload);
    },
    setThreshold(context: any, payload: any) {
        context.commit('updateThreshold', payload);
    },
    setTrafficDoor(context: any, payload: any) {
        context.commit('updateTrafficDoor', payload);
    },
    setDoorMeasure(context: any, payload: any) {
        context.commit('updateDoorMeasure', payload);
    },
    setDoorLeafSizes(context: any) {
        measureService.fetchDoorLeafSizes().then((response: any) => {
            context.commit('updateDoorLeafSizes', response.data);
        })
    },
    async setCharacteristicDependencies(context: any, chacrateristicCode: string) {
        //debugger;
        var meassureModelCharacteristics = context.getters.getMeasureCharacteristics;
        const anchor: any = meassureModelCharacteristics.filter(
            (item: any) => item.code === chacrateristicCode)[0];

        const doorConfiguration = context.rootState.configuratorModule.doorConfiguration;
        const filteredDependencies = doorConfiguration.GetDependenciesByCharacteristic(chacrateristicCode);
        const characteristic = functionsService.extractDependencies(anchor.id, filteredDependencies)
        .then((response: any) => {
            context.commit('updateCharacteristicDependencies', response.data);
        });
    },
    addCharacterisitc(context: any, { characteristic, valueDefinition }: any) {
        const selectedCharacteristic = MapCharacteristicAndValue(characteristic, valueDefinition);
        const configuration = context.rootState.configuratorModule.doorConfiguration;
        configuration.Add(DoorConfiguration.Measure, selectedCharacteristic);
    },
    checkBoxAddCharacteristic(context: any, characteristicCode: string) {
        const chart: Characteristic = getAppropValue(characteristicCode, context);
        context.rootState.configuratorModule.doorConfiguration.Add(DoorConfiguration.Measure, chart);

        // if (characteristicCode === 'CUST_MM_ABSENKDICHTUNG') {
        //     const absenkdichtungValue = absenkdichtung.getAbsenkdichtungLLTValue();
        //     const absenkdichtungTwoValue = absenkdichtung.getAbsenkdichtungTwoLLTValue();
        //     context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.Measure, 'KTU_MM_ABSENKDICHTUNG', absenkdichtungValue);
        //     context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.Measure, 'KTU_MM_ABSENKDICHTUNG2', absenkdichtungTwoValue);
        // }
    },
    updateabsenkdichtungValues(context: any) {
        const absenkdichtungValue = absenkdichtung.getAbsenkdichtungLLTValue();
        const absenkdichtungTwoValue = absenkdichtung.getAbsenkdichtungTwoLLTValue();
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.Measure, 'KTU_MM_ABSENKDICHTUNG', absenkdichtungValue);
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.Measure, 'KTU_MM_ABSENKDICHTUNG2', absenkdichtungTwoValue);
    },
    valueAddCharacteristic(context: any, { characteristicValue, value }: any) {
        let toParse = ['KTU_MM_MLB', 'KTU_MM_BMLH', 'KTU_MM_GBMLH', 'KTU_MM_STLB', 'KTU_MM_BSTLH', 'KTU_MM_GBSTLH'];
        if(toParse.includes(characteristicValue.code))
            value =  parseFloatFromGermanFloat(value);

        // debugger;
        characteristicValue.values[0].value = Number(value);
        const selectedCharacteristic = MapCharacteristicAndValue(characteristicValue, characteristicValue.values[0]);
        context.rootState.configuratorModule.doorConfiguration.AddNumericCharacteristic(DoorConfiguration.Measure, selectedCharacteristic);
        setDoorWidthMeasurementsFormula(context.rootState.configuratorModule.doorConfiguration);
        setTuerbandANZ(context.rootState.configuratorModule.doorConfiguration);   
    },
    setDoorWidthMeasurements(context: any) {
        setDoorWidthMeasurementsFormula(context.rootState.configuratorModule.doorConfiguration);
        setTuerbandANZ(context.rootState.configuratorModule.doorConfiguration);
    },
    setDoorWidthandTopMeasurements(context: any) {
        setDoorWidthMeasurementsFormula(context.rootState.configuratorModule.doorConfiguration);
    },
    setDoorLeafCharacteristic(context: any, characteristicCode: string) {
        context.commit('setDoorLeafCharacteristic', characteristicCode);
    },
    setSingleCharacteristicsFilteredOrDefaults(context: any) {
        context.commit('updateSingleCharacteristicsFilteredOrDefaults');
    },
    setMaterials(context: any) {
        const materials = store.getters['configuratorModule/getCurrentDoorConfiguration'].GetRegisteredMaterials();
        context.commit('updateClearMaterials');
        materials.forEach((element: any) => {
            if (element.value.value !== 'NEIN') {
                const characteristics = frameSelectionService.getMaterialsByParent(element.value.value)
                .then((response: any) => {
                    context.commit('updateMaterials', response.data);
                });
            }
        });
    },
    initMeasureModule(context : any, payload : any){
        context.commit('initMeasureModule', payload);
    },
    resetState(context : any)
    {
        context.commit('resetState');
    }
}

const mutations = {
    updateMeasureCharacteristics(s: any, payload: any) {
        s.model.characteristics = payload.characteristics;
    },
    updateThreshold(s: any, payload: any) {
        s.model.threshold = payload;
    },
    updateTrafficDoor(s: any, payload: any) {
        s.model.trafficDoor = payload;
    },
    updateDoorMeasure(s: any, payload: any) {
        s.model.doorMeasure = payload;
    },
    updateDoorLeafSizes(s: any, payload: any) {
        s.doorLeafSizes = payload
    },
    updateCharacteristicDependencies(s: any, payload: any) {
        const characteristic = payload.characteristics[0];
        if (typeof characteristic !== 'undefined') {
            addOrReplaceCharacteristic(characteristic, s);
            addSingleCharacteristicsFilteredOrDefaults(s);
        }
    },
    updateSingleCharacteristicsFilteredOrDefaults(s: any) {
        addSingleCharacteristicsFilteredOrDefaults(s);
    },
    setDoorLeafCharacteristic(s: any, payload: any) {
        s.doorLeafCharacteristic.characteristic = payload;
    },
    updateClearMaterials(s: any, payload: any) {
        s.model.materials = [];
    },
    updateMaterials(s: any, payload: any) {
        // console.log(payload.characteristic[0]);
        s.model.materials.push(payload.characteristic[0]);
    },
    initMeasureModule(context : any, payload : any){
        context.model.threshold = payload.model.threshold;
        context.model.trafficDoor = payload.model.trafficDoor;
        context.model.doorMeasure = payload.model.doorMeasure;
        context.model.materials = payload.model.materials;
    },
    resetState(s: any)
    {
        Object.assign(s, getDefaultState());
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

const setDoorWidthMeasurementsFormula = (doorConfiguration: any) => {
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_STLB', formula.calculateSTLB());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_BSTLH', formula.calculateBSTLH());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_GBSTLH', formula.calculateGBSTLH());

    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_MLB', formula.calculateMLB());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_BMLH', formula.calculateBMLH());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_GBMLH', formula.calculateGBMLH());

    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_DLB_90', formula.calculateDLB90());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_BDLH', formula.calculateBDLH());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_GBDLH', formula.calculateGBDLH());

    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_BSTMB', formula.calculateBSTMB());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_BSTMH', formula.calculateBSTMH());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_GBSTMB', formula.calculateGBSTMB());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_GBSTMH', formula.calculateGBSTMH());

    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_NIVEAU_HOEHE', formula.calculateNiveauHoehe());

    const absenkdichtungValue = absenkdichtung.getAbsenkdichtungLLTValue();
    const absenkdichtungTwoValue = absenkdichtung.getAbsenkdichtungTwoLLTValue();
    doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.Measure, 'KTU_MM_ABSENKDICHTUNG', absenkdichtungValue);
    doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.Measure, 'KTU_MM_ABSENKDICHTUNG2', absenkdichtungTwoValue);

    //Fermacel horizontal 
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_FERMACELL_S_LAENGE', otherFormula.calculateFERMACELLSLAENGE());

    //Fermacel vertikal 
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_FERMACELL_W_LAENGE', otherFormula.calculateFERMACELLWLAENGE());

    setTopPanelMeasurementsFormula(doorConfiguration);
};

const setTopPanelMeasurementsFormula = (doorConfiguration: any) => {
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_DGLH_O', otherFormula.calculateDGLHO());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_O_BREITE', otherFormula.calculateOBREITE());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_TUERBLATTHOEHE', otherFormula.calculateTUERBLATTHOEHE());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_TUERBLATTHOEHE_MIT_O', otherFormula.calculateTUERBLATTHOEHEMITO());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_O_HOEHE', otherFormula.calculateOHOEHE());

    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_STAFFEL_HOEHE', otherFormula.calculateSTAFFELHOEHE());


    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_STAFFEL_BREITE', otherFormula.calculateSTAFFELBREITE());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_STAFFEL_TIEFE', otherFormula.calculateSTAFFELTIEFE());

    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_AUSFAELZUNG', otherFormula.calculateAUSFAELZUNG());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_TUERBLATTBREITE', otherFormula.calculateTUERBLATTBREITE());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_TUERBLATTBREITE_GES', otherFormula.calculateTUERBLATTBREITEGES());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_GEHFLUEGEL_BREITE', otherFormula.calculateGEHFLUEGELBREITE());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_DGLB_90_GEHFLUEGEL', otherFormula.calculateDGLB90GEHFLUEGEL());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_TUERBLATTBREITE_STEHFLG', otherFormula.calculateTUERBLATTBREITESTEHFLG());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_TUERBLATTHOEHE_OHNE_O', otherFormula.calculateTUERBLATTHOEHEOHNEO());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_ZARGEN_HOEHE_BS', otherFormula.calculateZARGENHOEHEBS());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_ZARGEN_HOEHE_GBS', otherFormula.calcualteZARGENHOEHEGBS());

    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_ZARGEN_BREITE', otherFormula.calculateZARGENBREITE());

    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_FUTTERPLATTE_S_BREITE', otherFormula.calculateFUTTERPLATTESBREITE());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_FUTTERPLATTE_S_LAENGE', otherFormula.calculateFUTTERPLATTESLAENGE());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_FUTTERPLATTE_W_BREITE', otherFormula.calculateFUTTERPLATTEWBREITE());
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_FUTTERPLATTE_W_LAENGE', otherFormula.calculateFUTTERPLATTEWLAENGE());
    // doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_BLINDSTOCK_S_BREITE', otherFormula.calculateBLINDSTOCKSBREITE());
    // doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_BLINDSTOCK_S_HOEHE', otherFormula.calculateBLINDSTOCKSHOEHE());
    // doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_BLINDSTOCK_S_LAENGE', otherFormula.calculateBLINDSTOCKSLAENGE());
    // doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_BLINDSTOCK_W_BREITE', otherFormula.calculateBLINDSTOCKWBREITE());
    // doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_BLINDSTOCK_W_HOEHE', otherFormula.calculateBLINDSTOCKWHOEHE());
    // doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_BLINDSTOCK_W_LAENGE', otherFormula.calculateBLINDSTOCKWLAENGE());

    // doorConfiguration.valueAddCharacteristic(DoorConfiguration.Measure, 'KTU_MM_ABSENKDICHTUNG', absenkdichtung.getAbsenkdichtungLLTValue());
};

const setTuerbandANZ = (doorConfiguration: any) => {
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_TUERBAND_ANZ', otherFormula.calculateTuerBandANZ());
}



const setThresholdMeasurementsFormula = (doorConfiguration: any) => {
    // doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_STLB', formula.calculateSTLB());
};

const setDoorLeafExtensionMeasurementsFormula = (doorConfiguration: any) => {
    // doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Measure, 'KTU_MM_STLB', formula.calculateSTLB());
};